export default __webpack_public_path__ + "static/media/service.17a8c60b.svg";